import {useContext, useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import {Card, CardContent, Chip} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import CustomerHeader from "../common/CustomerHeader";
import Divider from "@mui/material/Divider";
import {getCustomerIntentSuccess} from "../common/api/PortalCustomerApi"
import {formatCurrency, formatDateTime} from "../common/Utils";
import Footer from "../Footer";
import MDButton from "../../components/MDButton";
import Loading from "../common/Loading";
import {AppContext} from "../../lib/AppContext";
import {CartContext} from "../../lib/CartProvider";
import PersonIcon from '@mui/icons-material/Person';
import {CompanyContext} from "../../lib/CompanyProvider";
import Meta from "../common/Meta";

export default function CheckoutFinal(props) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState();
  const [isCancel, setIsCancel] = useState(props?.isCancel);
  const [searchParams, setSearchParams] = useSearchParams();

  let {paymentIntentId} = useParams();

  const [salesReady, setSalesReady] = useState(false);
  const [salesResp, setSalesResp] = useState();
  const [searchTimer, setSearchTimer] = useState(1);
  const [paymentIntent, setPaymentIntent] = useState();

  useEffect(()=> {
    if(paymentIntentId) {
      setPaymentIntent(paymentIntentId);
      setSearchTimer(searchTimer + 1);
    }
  }, [paymentIntentId]);

  useEffect(()=>{
    if (salesReady) {
      let _c = {...cartContext};
      _c.reloadCart = true;
      setCartContext({..._c});
    }
  }, [salesReady]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (paymentIntent) {
        if (searchTimer > 1) {
          if (searchTimer < 30) {
            getSalesFn(paymentIntent);
          } else {
            navigate('/cx/my-purchases');
          }
        }
      }
    }, 1000);
    return () => clearTimeout(searchTimer);
  }, [searchTimer]);
  
  const getSalesFn = async (paymentIntent) => {
    let result = await getCustomerIntentSuccess(paymentIntent);
    if (result) {
      if (result?.salesItems?.length > 0) {
        setSalesResp(result);
        setSalesReady(true);
      } else {
        setSearchTimer(searchTimer + 1);
      }
    }
  }

  return (
    <CustomerPageLayout>
      <Meta pageTitle={'Checkout'}/>
      <CustomerHeader props={props}/>
      {!salesReady && <Loading/> }
      {salesReady && <MDBox p={3}>
        <MDBox m={3}>
          <Grid container cols={1} spacing={3} direction="row">
            <Grid item xs={12} sm={12}>
              <Card>
                <CardContent>
                  <MDTypography variant="h5" color="secondary" fontWeight="light">
                    My Purchase
                    <MDButton
                      color="info"
                      size="small"
                      style={{
                        float: 'right'
                      }}
                      onClick={(e) => {
                        navigate('/cx/my-profile');
                      }}>
                      <PersonIcon />&nbsp;My Profile
                    </MDButton>
                    <Divider/>
                  </MDTypography>
                </CardContent>

                <MDBox p={3}>
                  <MDTypography variant={'h6'}>Total
                    Purchases: {salesReady && formatCurrency(salesResp?.totalSales)}</MDTypography>

                  <ul className={'list-group'}>
                    {salesReady && salesResp?.salesItems.sort((a, b) => a.itemName.toUpperCase() > b.itemName.toUpperCase() ? 1 : -1).map((item, index) => {
                        return (
                          <li
                            className={'list-group-item'}
                            key={index}>
                                    <span
                                      style={{
                                        float:'right'
                                      }} >
                                      <Chip
                                        label={formatCurrency(item.total - item.discount)}
                                        variant="outlined"
                                        color="secondary"/>
                                    </span>&nbsp;
                            {item?.itemName}
                            <br/>
                            <small>{formatDateTime(item.purchaseDate)}</small>

                          </li>
                        )
                      }
                    )}
                  </ul>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      }
      <Footer/>
    </CustomerPageLayout>
  );
}